import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';

import { TableRow, TableRowColumn } from 'material-ui/Table';
import RaisedButton from 'material-ui/RaisedButton';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import Checkbox from 'material-ui/Checkbox';

import {
    updateLoadingAndDischarging,
    deleteLoadingAndDischarging,
    saveStatusLoadingAndDischarging,
    clearStatusLoadingAndDischarging,
} from 'actions/cargoes/ldRates';

import styles from 'styles';

class CargoLDRatesRow extends React.Component {
    constructor(props) {
        super(props);

        const { item } = this.props;

        if (!item.ldRates) {
            item.ldRates = {
                loading: {
                    dimension: '',
                    speed: '',
                    abbreviation: '',
                    term: '',
                    cqd: false,
                },
                discharging: {
                    dimension: '',
                    speed: '',
                    abbreviation: '',
                    term: '',
                    cqd: false,
                },
            };
        }

        this.state = {
            item,
        };

        this.handleChangeSelect = this.handleChangeSelect.bind(this);
        this.handleChangeCheckbox = this.handleChangeCheckbox.bind(this);

        this.handleUpdateItem = this.handleUpdateItem.bind(this);
        this.handleDeleteItem = this.handleDeleteItem.bind(this);
    }

    shouldComponentUpdate(nextProps) {
        return nextProps.item !== this.props.item;
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (!nextProps.item.ldRates) {
            nextProps.item.ldRates = {
                loading: {
                    dimension: '',
                    speed: '',
                    abbreviation: '',
                    term: '',
                    cqd: false,
                },
                discharging: {
                    dimension: '',
                    speed: '',
                    abbreviation: '',
                    term: '',
                    cqd: false,
                },
            };
        }

        if (!_.isEqual(nextProps.item, this.props.item)) {
            this.setState({
                item: nextProps.item,
            });
        }
    }

    handleChangeCheckbox(type) {
        const { item } = this.state;
        item.isUpdate = true;

        item.ldRates[type[0]][type[1]] = !item.ldRates[type[0]][type[1]];

        this.setState({
            item,
        }, () => {
            this.props.saveStatusLoadingAndDischarging(this.state.item);
        });
    }

    handleChangeSelect(value, dropdown) {
        const { item } = this.state;
        let ldRates = _.cloneDeep(item.ldRates);

        item.isUpdate = true;
        ldRates[dropdown[0]][dropdown[1]] = value;

        this.setState({
            item: {
                ...item,
                ldRates,
            },
        }, () => {
            this.props.saveStatusLoadingAndDischarging(this.state.item);
        });
    }

    handleUpdateItem() {
        const { item } = this.state;

        item.isUpdate = false;
        this.setState({
            item,
        }, () => {
            this.props.updateLoadingAndDischarging(this.state.item);
        });
    }

    handleDeleteItem() {
        this.props.deleteLoadingAndDischarging(this.state.item);
    }

    render() {
        const { item } = this.state;

        return (
            <TableRow>
                <TableRowColumn style={styles.tableRowColumnCSS}>{item.value}</TableRowColumn>
                <TableRowColumn style={styles.tableRowColumnCSS}>
                    <SelectField
                        style={styles.selectFieldCSS}
                        value={_.has(item, 'ldRates.loading.dimension') ? item.ldRates.loading.dimension : ''}
                        onChange={(event, index, value) => { this.handleChangeSelect(value, ['loading', 'dimension']); }}
                        disabled={_.has(item, 'ldRates.loading.cqd') ? item.ldRates.loading.cqd : false}
                        maxHeight={200}
                        autoWidth
                    >
                        {this.props.termEntities.dimensions.map((d, key) => {
                            return <MenuItem key={key} style={styles.menuItemCSS} value={d} primaryText={d} />;
                        })}
                    </SelectField>
                    <SelectField
                        style={styles.selectFieldCSS}
                        value={_.has(item, 'ldRates.discharging.dimension') ? item.ldRates.discharging.dimension : ''}
                        onChange={(event, index, value) => { this.handleChangeSelect(value, ['discharging', 'dimension']); }}
                        disabled={_.has(item, 'ldRates.discharging.cqd') ? item.ldRates.discharging.cqd : false}
                        maxHeight={200}
                        autoWidth
                    >
                        {this.props.termEntities.dimensions.map((d, key) => {
                            return <MenuItem key={key} style={styles.menuItemCSS} value={d} primaryText={d} />;
                        })}
                    </SelectField>
                </TableRowColumn>
                <TableRowColumn style={styles.tableRowColumnCSS}>
                    <SelectField
                        style={styles.selectFieldCSS}
                        value={_.has(item, 'ldRates.loading.speed') ? item.ldRates.loading.speed : ''}
                        onChange={(event, index, value) => { this.handleChangeSelect(value, ['loading', 'speed']); }}
                        disabled={_.has(item, 'ldRates.loading.cqd') ? item.ldRates.loading.cqd : false}
                        maxHeight={200}
                        autoWidth
                    >
                        {this.props.termEntities.speed.map((s, key) => {
                            return <MenuItem key={key} style={styles.menuItemCSS} value={s} primaryText={s} />;
                        })}
                    </SelectField>
                    <SelectField
                        style={styles.selectFieldCSS}
                        value={_.has(item, 'ldRates.discharging.speed') ? item.ldRates.discharging.speed : ''}
                        onChange={(event, index, value) => { this.handleChangeSelect(value, ['discharging', 'speed']); }}
                        disabled={_.has(item, 'ldRates.discharging.cqd') ? item.ldRates.discharging.cqd : false}
                        maxHeight={200}
                        autoWidth
                    >
                        {this.props.termEntities.speed.map((s, key) => {
                            return <MenuItem key={key} style={styles.menuItemCSS} value={s} primaryText={s} />;
                        })}
                    </SelectField>
                </TableRowColumn>
                <TableRowColumn style={styles.tableRowColumnCSS}>
                    <SelectField
                        style={styles.selectFieldCSS}
                        value={_.has(item, 'ldRates.loading.abbreviation') ? item.ldRates.loading.abbreviation : ''}
                        onChange={(event, index, value) => { this.handleChangeSelect(value, ['loading', 'abbreviation']); }}
                        disabled={_.has(item, 'ldRates.loading.cqd') ? item.ldRates.loading.cqd : false}
                        maxHeight={200}
                        autoWidth
                    >
                        {this.props.termEntities.abbreviation.map((a, key) => {
                            return <MenuItem key={key} style={styles.menuItemCSS} value={a} primaryText={a.toUpperCase()} />;
                        })}
                    </SelectField>
                    <SelectField
                        style={styles.selectFieldCSS}
                        value={_.has(item, 'ldRates.discharging.abbreviation') ? item.ldRates.discharging.abbreviation : ''}
                        onChange={(event, index, value) => { this.handleChangeSelect(value, ['discharging', 'abbreviation']); }}
                        disabled={_.has(item, 'ldRates.discharging.cqd') ? item.ldRates.discharging.cqd : false}
                        maxHeight={200}
                        autoWidth
                    >
                        {this.props.termEntities.abbreviation.map((a, key) => {
                            return <MenuItem key={key} style={styles.menuItemCSS} value={a} primaryText={a.toUpperCase()} />;
                        })}
                    </SelectField>
                </TableRowColumn>
                <TableRowColumn style={styles.tableRowColumnCSS}>
                    <SelectField
                        style={styles.selectFieldCSS}
                        value={_.has(item, 'ldRates.loading.term') ? item.ldRates.loading.term : ''}
                        onChange={(event, index, value) => { this.handleChangeSelect(value, ['loading', 'term']); }}
                        disabled={_.has(item, 'ldRates.loading.cqd') ? item.ldRates.loading.cqd : false}
                        maxHeight={200}
                        autoWidth
                    >
                        {this.props.termEntities.term.map((t, key) => {
                            return <MenuItem key={key} style={styles.menuItemCSS} value={t} primaryText={t.toUpperCase()} />;
                        })}
                    </SelectField>
                    <SelectField
                        style={styles.selectFieldCSS}
                        value={_.has(item, 'ldRates.discharging.term') ? item.ldRates.discharging.term : ''}
                        onChange={(event, index, value) => { this.handleChangeSelect(value, ['discharging', 'term']); }}
                        disabled={_.has(item, 'ldRates.discharging.cqd') ? item.ldRates.discharging.cqd : false}
                        maxHeight={200}
                        autoWidth
                    >
                        {this.props.termEntities.term.map((t, key) => {
                            return <MenuItem key={key} style={styles.menuItemCSS} value={t} primaryText={t.toUpperCase()} />;
                        })}
                    </SelectField>
                </TableRowColumn>
                <TableRowColumn style={styles.tableRowColumnSmallCSS}>
                    <Checkbox
                        checked={_.has(item, 'ldRates.loading.cqd') ? item.ldRates.loading.cqd : false}
                        onCheck={() => { this.handleChangeCheckbox(['loading', 'cqd']); }}
                    />
                    <Checkbox
                        checked={_.has(item, 'ldRates.discharging.cqd') ? item.ldRates.discharging.cqd : false}
                        onCheck={() => { this.handleChangeCheckbox(['discharging', 'cqd']); }}
                    />
                </TableRowColumn>
                <TableRowColumn style={styles.tableRowColumnSmallCSS}>
                    <div className={item.isUpdate ? 'update-item' : 'hidden update-item'}>
                        <RaisedButton label='UPDATE' primary onClick={this.handleUpdateItem} />
                    </div>
                </TableRowColumn>
                <TableRowColumn style={styles.tableRowColumnSmallCSS}>
                    <RaisedButton label='Delete' secondary onClick={this.handleDeleteItem} />
                </TableRowColumn>
            </TableRow>
        );
    }
}

export default connect(
    (state, ownProps) => {
        const item = ownProps.item;
        const termEntities = ownProps.termEntities;

        return {
            item,
            termEntities,
        };
    },
    dispatch => bindActionCreators({
        updateLoadingAndDischarging,
        deleteLoadingAndDischarging,
        saveStatusLoadingAndDischarging,
        clearStatusLoadingAndDischarging,
    },
    dispatch),
)(CargoLDRatesRow);



// WEBPACK FOOTER //
// ./app/components/Cargoes/LDRates/Row.jsx